import { render, staticRenderFns } from "./settings-organization-inbox-urls.vue?vue&type=template&id=6cd92c1b&scoped=true&"
import script from "./settings-organization-inbox-urls.vue?vue&type=script&lang=js&"
export * from "./settings-organization-inbox-urls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd92c1b",
  null
  
)

export default component.exports